module.exports = "<span class=\"timing\" *ngIf=\"visible === true && displayMode == 'standard' && timerDisplayText\">\r\n    Time Remaining: <strong [ngClass]=\"{'hurry-up': runningLowOnTime === true}\">{{timerDisplayText}}</strong>\r\n</span>\r\n<span class=\"timing-speaking\" *ngIf=\"visible === true && displayMode == 'speaking'\">\r\n    Preparation Time: <strong>{{speakingPreparationTime}} seconds</strong><br />\r\n    Speaking Time: <strong>{{speakingRecordingTime}} seconds</strong>\r\n</span>"


//////////////////
// WEBPACK FOOTER
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/top-nav/timer/timer.component.html
// module id = 2coj
// module chunks = 1